import { Routes, Route } from "react-router-dom";
import LandingPage from "./routes/index";
import FeaturesPage from "./routes/features";
import LoginPage from "./routes/login";
import ForgotPasswordPage from "./routes/forgot-password";
import ResetPasswordPage from "./routes/reset-password";
import PricingPage from "./routes/pricing";
import TermsPage from "./routes/terms";
import PrivacyPage from "./routes/privacy";
import NotFoundPage from "./routes/not-found";
import AppLayout from "./routes/app/layout";
import DashboardPage from "./routes/app/index";
import SettingsPage from "./routes/app/settings";
import NewProjectPage from "./routes/app/new";
import ProjectDetailPage from "./routes/app/project-detail";
import VoicesPage from "./routes/app/voices";
import NewVoicePage from "./routes/app/voice-new";
import VoiceDetailPage from "./routes/app/voice-detail";
import SchedulePage from "./routes/app/schedule";
import AutoPlugPage from "./routes/app/auto-plug";
import AnalyticsPage from "./routes/app/analytics";
import EvergreenPage from "./routes/app/evergreen";
import QueuePage from "./routes/app/queue";
import AutoRetweetPage from "./routes/app/auto-retweet";
import HooksPage from "./routes/app/hooks";
import DraftsPage from "./routes/app/drafts";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/features" element={<FeaturesPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="new" element={<NewProjectPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="voices" element={<VoicesPage />} />
        <Route path="voices/new" element={<NewVoicePage />} />
        <Route path="voices/:id" element={<VoiceDetailPage />} />
        <Route path="queue" element={<QueuePage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="auto-plug" element={<AutoPlugPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="evergreen" element={<EvergreenPage />} />
        <Route path="auto-retweet" element={<AutoRetweetPage />} />
        <Route path="hooks" element={<HooksPage />} />
        <Route path="drafts" element={<DraftsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
